export default "__VITE_ASSET__3a976a28__"